const A = "/brand";

const primary = {
  headshot: `${A}/blueprint4joy-speaking-testimonial-woodstgermain.jpg`,
  name: "Wood J. St-Germain, PMP, MBA",
  role: null,
  quote:
    "In business transformation, clarity drives results. Lara helps people find that clarity, not through hype, but through insight and disciplined reflection that actually sticks.",
};

const pullQuotes = [
  {
    name: "Jo Berry, CBE",
    role: null,
    quote:
      "Lara creates spaces where honest dialogue and practical insight meet. Audiences leave changed, not just inspired.",
  },
  {
    name: "Gina Marquez",
    role: "Enterprise Technology Leader",
    quote:
      "I operate in a high-performance environment where clarity is everything. Lara helped me reconnect to what drives my best decisions, and that has changed how I lead.",
  },
  {
    name: "Carrie Lewis",
    role: "Registered Nurse & Disability Advocate",
    quote:
      "During a time of deep uncertainty, Lara brought clarity without oversimplifying the challenge. Her ability to reframe difficult realities while honoring them is powerful. Her message stays with you long after the event ends.",
  },
];

export function SpeakingTestimonials() {
  return (
    <section
      data-testid="speaking-testimonials-section"
      className="relative overflow-hidden"
      style={{ background: "#FAFAF8" }}
    >
      {/* Post-event conversation — fixed aspect ratio (stable crop on every screen), loose headroom above faces */}
      <div className="relative w-full overflow-hidden aspect-[4/3] sm:aspect-[16/9] lg:aspect-[21/9]">
        <img
          src={`${A}/blueprint4joy-speaking-room-leaves.png`}
          alt="Lara laughing with attendees after a keynote while signing a copy of The Word You Carry."
          loading="lazy"
          className="w-full h-full object-cover"
          style={{ objectPosition: "50% 4%" }}
        />
        {/* Top fade dissolves from previous section */}
        <div
          aria-hidden
          className="absolute inset-x-0 top-0 h-24 z-[1]"
          style={{ background: "linear-gradient(to bottom, #F8F7F5 0%, transparent 100%)" }}
        />
        {/* Bottom fade into testimonials */}
        <div
          aria-hidden
          className="absolute inset-x-0 bottom-0 h-48 z-[1]"
          style={{ background: "linear-gradient(to top, #FAFAF8 0%, transparent 100%)" }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-4 md:pt-6 pb-12 md:pb-16">

        <div className="mb-8 md:mb-12 reveal">
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-[#1C1917]">
            The room leaves different.
          </h2>
        </div>

        {/* Primary testimonial */}
        <figure
          data-testid="speaking-testimonial-primary"
          className="reveal grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16 md:mb-24"
        >
          <div className="lg:col-span-4">
            <div className="relative overflow-hidden" style={{ aspectRatio: "4/5", maxWidth: "320px" }}>
              <img
                src={primary.headshot}
                alt={primary.name}
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
              <div
                className="absolute inset-x-0 top-0 h-16 z-[1]"
                style={{ background: "linear-gradient(to bottom, rgba(250,250,248,0.55) 0%, transparent 100%)" }}
              />
              <div
                className="absolute inset-y-0 right-0 w-20 z-[1]"
                style={{ background: "linear-gradient(to left, rgba(250,250,248,0.45) 0%, transparent 100%)" }}
              />
              <div
                className="absolute inset-x-0 bottom-0 h-24 z-[1]"
                style={{ background: "linear-gradient(to top, rgba(250,250,248,0.45) 0%, transparent 100%)" }}
              />
            </div>
          </div>

          <div className="lg:col-span-8 flex flex-col justify-center">
            <blockquote className="font-display text-3xl md:text-4xl lg:text-[46px] leading-snug text-[#1C1917] mb-8">
              "{primary.quote}"
            </blockquote>
            <figcaption>
              <p className="font-display text-lg text-[#1C1917]">{primary.name}</p>
              {primary.role && (
                <p className="text-base text-[#57534E] mt-1">{primary.role}</p>
              )}
            </figcaption>
          </div>
        </figure>

        <div className="w-full h-px bg-[#E8E6E3] mb-12 md:mb-14" />

        {/* Three pull quotes */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-10">
          {pullQuotes.map((t, i) => (
            <figure
              key={i}
              data-testid={`speaking-testimonial-${i}`}
              className="reveal flex flex-col"
            >
              <span
                className="font-display text-5xl leading-none mb-5 select-none"
                style={{ color: "#F6A041" }}
                aria-hidden
              >
                "
              </span>
              <blockquote className="font-display text-xl md:text-2xl leading-relaxed text-[#2E2E2E] mb-8 flex-1">
                {t.quote}
              </blockquote>
              <figcaption>
                <div className="w-8 h-px bg-[#F6A041] mb-4" />
                <p className="text-sm font-medium tracking-[0.12em] uppercase text-[#1C1917]">
                  {t.name}
                </p>
                {t.role && (
                  <p className="text-sm text-[#78716C] mt-1">{t.role}</p>
                )}
              </figcaption>
            </figure>
          ))}
        </div>

      </div>
    </section>
  );
}

